// EYS geo-redirect v3.1 (cache-bust 2026-06-17-1500)
(function () {
  'use strict';

  if (window.Shopify && window.Shopify.designMode) return;

  var config = window.__EYS_GEO_REDIRECT__;
  if (!config || !config.enabled) return;

  var BOT_RE = /Googlebot|Bingbot|YandexBot|DuckDuckBot|Baiduspider|Slurp|facebookexternalhit|Twitterbot|LinkedInBot|Applebot/i;
  var ATTEMPT_KEY = 'eys_geo_redirect_attempted';
  var ATTEMPT_COOLDOWN_MS = 10000; // 10s window — blocks back-button bounce, allows deliberate revisits
  var BANNER_DISMISSED_KEY = 'eys_geo_banner_dismissed';
  var OVERRIDE_COOKIE = 'eys_region_override';
  var OVERRIDE_DAYS = 30;

  if (BOT_RE.test(navigator.userAgent)) {
    revealPage();
    return;
  }

  var urlParams = new URLSearchParams(window.location.search);
  var forceParam = urlParams.get('force');
  if (forceParam) {
    setOverrideCookie(forceParam);
    urlParams.delete('force');
    var newSearch = urlParams.toString();
    var newUrl = window.location.pathname + (newSearch ? '?' + newSearch : '') + window.location.hash;
    history.replaceState(null, '', newUrl);
    revealPage();
    return;
  }

  if (getCookie(OVERRIDE_COOKIE)) {
    revealPage();
    return;
  }

  var attempted;
  try { attempted = sessionStorage.getItem(ATTEMPT_KEY); } catch (e) { attempted = null; }
  if (attempted) {
    var attemptedAt = parseInt(attempted, 10);
    if (!isNaN(attemptedAt) && (Date.now() - attemptedAt) < ATTEMPT_COOLDOWN_MS) {
      revealPage();
      return;
    }
  }

  if (config.mode === 'off') {
    revealPage();
    return;
  }

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var endpoint = root + 'browsing_context_suggestions.json?country[enabled]=true';

  fetch(endpoint, { credentials: 'same-origin' })
    .then(function (r) { return r.ok ? r.json() : null; })
    .then(function (data) {
      if (!data || !data.detected_values || !data.detected_values.country) {
        revealPage();
        return;
      }

      var detected = data.detected_values.country.handle;
      if (!detected) {
        revealPage();
        return;
      }

      if (!shouldTrigger(detected, config)) {
        revealPage();
        return;
      }

      if (config.mode === 'hard-redirect') {
        try { sessionStorage.setItem(ATTEMPT_KEY, String(Date.now())); } catch (e) {}
        var targetUrl = config.targetUrl.replace(/\/$/, '') + window.location.pathname + window.location.search + window.location.hash;
        window.location.replace(targetUrl);
        return;
      }

      if (config.mode === 'soft-banner') {
        revealPage();
        if (!sessionStorage.getItem(BANNER_DISMISSED_KEY)) {
          showBanner(config);
        }
        return;
      }

      revealPage();
    })
    .catch(function () {
      revealPage();
    });

  function shouldTrigger(detected, cfg) {
    if (!cfg.targetUrl) return false;
    if (cfg.triggerCountry === '*') {
      return detected !== cfg.homeCountry;
    }
    return detected === cfg.triggerCountry;
  }

  function revealPage() {
    document.documentElement.classList.remove('geo-pending');
  }

  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
  }

  function setOverrideCookie(value) {
    var maxAge = 60 * 60 * 24 * OVERRIDE_DAYS;
    document.cookie = OVERRIDE_COOKIE + '=' + encodeURIComponent(value) + '; max-age=' + maxAge + '; path=/; SameSite=Lax';
  }

  function showBanner(cfg) {
    var bannerText = cfg.bannerText || "Looks like you're shopping from outside our region. Visit your local store for the best experience.";
    var ctaLabel = cfg.bannerCtaLabel || 'Visit other site';
    var dismissLabel = cfg.bannerDismissLabel || 'Stay on this site';

    var banner = document.createElement('div');
    banner.id = 'eys-geo-banner';
    banner.setAttribute('role', 'dialog');
    banner.setAttribute('aria-live', 'polite');
    banner.style.cssText = [
      'position:fixed',
      'top:0',
      'left:0',
      'right:0',
      'z-index:9999',
      'background:#1a1a1a',
      'color:#fff',
      'padding:12px 16px',
      'font-size:14px',
      'line-height:1.4',
      'display:flex',
      'flex-wrap:wrap',
      'align-items:center',
      'justify-content:center',
      'gap:12px',
      'box-shadow:0 2px 8px rgba(0,0,0,0.15)'
    ].join(';');

    var msg = document.createElement('span');
    msg.textContent = bannerText;
    msg.style.cssText = 'flex:1 1 auto;min-width:200px;';

    var ctaBtn = document.createElement('a');
    ctaBtn.href = cfg.targetUrl;
    ctaBtn.textContent = ctaLabel;
    ctaBtn.style.cssText = [
      'background:#fff',
      'color:#1a1a1a',
      'padding:8px 16px',
      'border-radius:4px',
      'text-decoration:none',
      'font-weight:600',
      'flex:0 0 auto',
      'cursor:pointer'
    ].join(';');

    var dismissBtn = document.createElement('button');
    dismissBtn.type = 'button';
    dismissBtn.textContent = dismissLabel;
    dismissBtn.style.cssText = [
      'background:transparent',
      'color:#fff',
      'padding:8px 16px',
      'border:1px solid #fff',
      'border-radius:4px',
      'cursor:pointer',
      'font-size:14px',
      'flex:0 0 auto'
    ].join(';');
    dismissBtn.addEventListener('click', function () {
      try { sessionStorage.setItem(BANNER_DISMISSED_KEY, '1'); } catch (e) {}
      setOverrideCookie(cfg.homeCountry || 'home');
      banner.parentNode && banner.parentNode.removeChild(banner);
    });

    banner.appendChild(msg);
    banner.appendChild(ctaBtn);
    banner.appendChild(dismissBtn);

    if (document.body) {
      document.body.appendChild(banner);
    } else {
      document.addEventListener('DOMContentLoaded', function () {
        document.body.appendChild(banner);
      });
    }
  }
})();
